module.exports = __webpack_public_path__ + "static/hero-4-432ba7ed17e48e35443ff0c8da504e31.png";